// DO NOT EDIT -- generated from fs/services/llm-tool/llm.proto

import * as protobuf from '../../../google/protobuf';

/** This service contains generic APIs to call LLMs such as Gemini and GPT */
export namespace Llm {

  export const ChatCompletionEndpoint = "/grpc/llm_tool.Llm/ChatCompletion";
  /**
   * ChatCompletion is a basic call to the LLM model to complete a chat message
   * given a system prompt
   */
  export function ChatCompletion(sender: (req: ChatCompletionRequest, endpoint: string) => Promise<ChatCompletionResponse>, req: ChatCompletionRequest): { promise: () => Promise<ChatCompletionResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ChatCompletionEndpoint),
      endpoint: ChatCompletionEndpoint
    };
  }

  export const CountTokensEndpoint = "/grpc/llm_tool.Llm/CountTokens";
  export function CountTokens(sender: (req: CountTokensRequest, endpoint: string) => Promise<CountTokensResponse>, req: CountTokensRequest): { promise: () => Promise<CountTokensResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CountTokensEndpoint),
      endpoint: CountTokensEndpoint
    };
  }

  export const TextEmbeddingEndpoint = "/grpc/llm_tool.Llm/TextEmbedding";
  /** TextEmbedding returns the vector embedding of a given text. Depending on the model specified, the returned embedding may be of different lengths. */
  export function TextEmbedding(sender: (req: TextEmbeddingRequest, endpoint: string) => Promise<TextEmbeddingResponse>, req: TextEmbeddingRequest): { promise: () => Promise<TextEmbeddingResponse>, endpoint: string } {
    return {
      promise: () => sender(req, TextEmbeddingEndpoint),
      endpoint: TextEmbeddingEndpoint
    };
  }
}

export enum LlmModel {
  INVALID = 0,
  GPT3DOT5 = 1,
  GPT4 = 2,
  GPT4_VISION = 3,
  O1 = 11,
  O3_MINI = 12,
  GEMINI_1DOT5_PRO_VISION = 5,
  GEMINI_1DOT5_FLASH = 6,
  GEMINI_1DOT5_FLASH_8B = 9,
  GEMINI_2_FLASH = 13,
  GEMINI_2_FLASH_LITE = 15,
  GEMINI_2_PRO = 10,
  GEMINI_2_THINKING = 14
}

export interface Media {
  /** For use with GPT4_VISION, the public URL of an image */
  imageUrl?: string;
  /**
   * For use with GEMINI_PRO_VISION, the URI of an image in GCS, e.g.
   * "gs://bucket/image.jpg"
   */
  imageGsUri?: string;
  /**
   * For use with GEMINI_PRO_VISION, mp4 files only, e.g.
   * "gs://bucket/video.mp4"
   */
  videoGsUri?: string;
  /** For use with any vision model, containing raw image bytes. */
  image?: ImageData | null;
}

export namespace Media {
  export enum details {
    /** For use with GPT4_VISION, the public URL of an image */
    imageUrl = 1,
    /**
     * For use with GEMINI_PRO_VISION, the URI of an image in GCS, e.g.
     * "gs://bucket/image.jpg"
     */
    imageGsUri = 2,
    /**
     * For use with GEMINI_PRO_VISION, mp4 files only, e.g.
     * "gs://bucket/video.mp4"
     */
    videoGsUri = 3,
    /** For use with any vision model, containing raw image bytes. */
    image = 4
  }

  export function details_oneof(m: Media): { opt: details.image, val: ImageData } | { opt: details.imageGsUri, val: string } | { opt: details.imageUrl, val: string } | { opt: details.videoGsUri, val: string } | null {
    if (m.imageUrl != null) { return { opt: details.imageUrl, val: m.imageUrl } }
    if (m.imageGsUri != null) { return { opt: details.imageGsUri, val: m.imageGsUri } }
    if (m.videoGsUri != null) { return { opt: details.videoGsUri, val: m.videoGsUri } }
    if (m.image != null) { return { opt: details.image, val: m.image } }
    return null;
  }
}

export interface ImageData {
  /** HTTP Content-type (e.g., image/png). */
  contentType: string;
  /** Raw image data bytes. */
  data: protobuf.bytes;
}

export interface FloatValue {
  value: number;
}

export interface Int32Value {
  value: number;
}

export interface ModelOptions {
  temperature: FloatValue | null;
  functions: FunctionDecl[];
  /**
   * For fullstoryapp, use us-east1, and for fullstoryapp-eu1, use europe-west1
   * for bursty requests. This only applies to gemini requests Set to false
   * (default, unset) for consistent loads that require low latency, and the
   * alternative region is for batch jobs, async, those that are fine to be
   * retried later
   */
  useAlternativeRegion: boolean;
  responseMimeType: MimeType;
  responseSchema: Schema | null;
  maxOutputTokens: Int32Value | null;
}

export enum MimeType {
  TEXT_PLAIN = 0,
  APPLICATION_JSON = 1
}

export interface FunctionDecl {
  id: string;
  description: string;
  parameters: Schema | null;
  response: Schema | null;
}

export interface Schema {
  type: SchemaType;
  title: string;
  description: string;
  nullable: boolean;
  enum: string[];
  required: string[];
  /** Really optional, but go doesn't support that. */
  items: Schema[];
  properties: { [key: string]: Schema };
}

export enum SchemaType {
  TYPE_UNSPECIFIED = 0,
  TYPE_STRING = 1,
  TYPE_NUMBER = 2,
  TYPE_INTEGER = 3,
  TYPE_BOOLEAN = 4,
  TYPE_ARRAY = 5,
  TYPE_OBJECT = 6
}

export interface CacheOptions {
  expiration: number;
}

export interface ChatCompletionRequest {
  orgId: string;
  llmModel: LlmModel;
  modelOptions: ModelOptions | null;
  messages: ChatMessage[];
  integration: string;
  source: string;
  cacheOptions: CacheOptions | null;
  /** if true, store only metadata, not conversation text */
  incognito: boolean;
}

export interface ChatCompletionResponse {
  response: ChatMessage | null;
}

export interface CountTokensRequest {
  llmModel: LlmModel;
  text: string;
}

export interface CountTokensResponse {
  tokenCount: number;
}

/**
 * A ChatMessage is represents one turn of a conversation
 * Most commonly, single turn requests are used, so there will be a single part
 * with text_content, with a ROLE_USER
 * 
 * Constraints:
 * - Every message must alternate between ROLE_USER and ROLE_MODEL
 * - The system message is optional and if present must be the first message
 * - Models have varied constraints on tokens, number of images, order of parts,
 * etc For reference:
 * https://cloud.google.com/vertex-ai/generative-ai/docs/model-reference/inference
 */
export interface ChatMessage {
  role: Role;
  parts: ChatMessagePart[];
}

export enum Role {
  ROLE_INVALID = 0,
  ROLE_USER = 1,
  ROLE_MODEL = 2,
  ROLE_SYSTEM = 3
}

export interface FunctionCall {
  name: string;
  args: Object | null;
}

export interface FunctionResponse {
  name: string;
  returned: Object | null;
}

export interface Value {
  string?: string;
  number?: number;
  integer?: protobuf.int64;
  boolean?: boolean;
  object?: Object | null;
  array?: Array | null;
}

export namespace Value {
  export enum value {
    string = 1,
    number = 2,
    integer = 3,
    boolean = 4,
    object = 5,
    array = 6
  }

  export function value_oneof(m: Value): { opt: value.array, val: Array } | { opt: value.boolean, val: boolean } | { opt: value.integer, val: protobuf.int64 } | { opt: value.number, val: number } | { opt: value.object, val: Object } | { opt: value.string, val: string } | null {
    if (m.string != null) { return { opt: value.string, val: m.string } }
    if (m.number != null) { return { opt: value.number, val: m.number } }
    if (m.integer != null) { return { opt: value.integer, val: m.integer } }
    if (m.boolean != null) { return { opt: value.boolean, val: m.boolean } }
    if (m.object != null) { return { opt: value.object, val: m.object } }
    if (m.array != null) { return { opt: value.array, val: m.array } }
    return null;
  }
}

export interface Object {
  properties: { [key: string]: Value };
}

export interface Array {
  items: Value[];
}

export interface ChatMessagePart {
  textContent?: string;
  mediaContent?: Media | null;
  funcCall?: FunctionCall | null;
  funcResponse?: FunctionResponse | null;
}

export namespace ChatMessagePart {
  export enum part {
    textContent = 1,
    mediaContent = 2,
    funcCall = 3,
    funcResponse = 4
  }

  export function part_oneof(m: ChatMessagePart): { opt: part.funcCall, val: FunctionCall } | { opt: part.funcResponse, val: FunctionResponse } | { opt: part.mediaContent, val: Media } | { opt: part.textContent, val: string } | null {
    if (m.textContent != null) { return { opt: part.textContent, val: m.textContent } }
    if (m.mediaContent != null) { return { opt: part.mediaContent, val: m.mediaContent } }
    if (m.funcCall != null) { return { opt: part.funcCall, val: m.funcCall } }
    if (m.funcResponse != null) { return { opt: part.funcResponse, val: m.funcResponse } }
    return null;
  }
}

export enum EmbeddingModel {
  EMBEDDINGMODEL_INVALID = 0,
  EMBEDDINGMODEL_TEXT_EMBEDDING_005 = 1,
  EMBEDDINGMODEL_ADA_V2 = 2
}

export interface TextEmbeddingRequest {
  content: string;
  model: EmbeddingModel;
}

export interface TextEmbeddingResponse {
  embedding: number[];
}
